var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M0 0h34v34H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.936 15.438 26.53 6.8h-1.8l-6.593 7.5-5.267-7.5H6.795l7.965 11.342L6.795 27.2h1.8l6.964-7.92 5.562 7.92h6.074l-8.26-11.762h.001Zm-2.465 2.804-.807-1.13-6.42-8.986h2.764l5.181 7.252.807 1.13 6.736 9.427h-2.765l-5.496-7.693Z",
    fill: "#fff"
  })));
};
export default SvgTwitter;